import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type IthermalImageSlice = {
    currSelectedImage: string,
    minUpdatedTemp: number,
    maxUpdatedTemp: number,
    latestimageheight: number,
    latestimagewidth: number,
}

const initialState: IthermalImageSlice = {
    currSelectedImage: "",
    minUpdatedTemp: 0,
    maxUpdatedTemp: 0,
    latestimageheight: 0,
    latestimagewidth: 0,
}

export const thermalImageSlice = createSlice({
    name: "thermalImageSlice",
    initialState: initialState,
    reducers: {
        setImage: (state, action: PayloadAction<string>) => {
            state.currSelectedImage = action.payload
        },
        setTemp: (state, action: PayloadAction<{ minUpdatedTemp, maxUpdatedTemp }>) => {
            state.minUpdatedTemp = action.payload.minUpdatedTemp
            state.maxUpdatedTemp = action.payload.maxUpdatedTemp
        },
        setLatestImageHeightWidth: (state, action: PayloadAction<{ height, width }>) => {
            state.latestimagewidth = action.payload.width
            state.latestimageheight = action.payload.height
        },
        resetThermalImage: (state) => {
            state.currSelectedImage = ""
            state.minUpdatedTemp = 0
            state.maxUpdatedTemp = 0
        }
    }
});

export const {
    setImage,
    setTemp,
    resetThermalImage,
    setLatestImageHeightWidth
} = thermalImageSlice.actions


export default thermalImageSlice.reducer
